import React, { useEffect } from "react";
import { FaHome, FaSignOutAlt } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../assets/css/topbar.css";
import { toast } from "react-toastify";

function Topbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, isAuthenticated } = useAuth();
  const department = JSON.parse(localStorage.getItem("department"));

  // useEffect(() => {
  //   const mainRole = localStorage.getItem("main_role");
  //   const roleType = localStorage.getItem("type");
  //   if (mainRole !== "mainchairman" || roleType !== "Sanitary") {
  //     navigate("/");
  //   }
  // }, [navigate]);

  useEffect(() => {
    if (department === "pwd" && location.pathname === "/pwdsection") {
      navigate("/pwdsection");
    }
  }, [department, isAuthenticated, location.pathname, navigate]);

  const handleLogout = () => {
    localStorage.clear();
    logout();
    toast.success("Logout successful");
    navigate("/");
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="text-white">Chairman Desk</h2>
      </div>
      <div className="topbar-right">
        {department === "pwd" ? (
          <Link className="text-white text-decoration-none" to="/pwdsection">
            <div className="icon-circle">
              <FaHome className="icon" />
            </div>
          </Link>
        ) : (
          <Link className="text-white text-decoration-none" to="/dashboard">
            <div className="icon-circle">
              <FaHome className="icon" />
            </div>
          </Link>
        )}

        <Link className="text-white text-decoration-none" to="/">
          <div className="icon-circle" onClick={handleLogout}>
            <FaSignOutAlt className="icon" />
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Topbar;
